<template>
    <div id="multilingual">
        <a-row class="mtb8">
            <img class="sbxs mllr4" @click="createLang" src="../../../assets/img/ss-add.png" width="25" height="25" >
            <a-popconfirm
                    :title="$t('generic.AreyoudeleTask')"
                    @confirm="langDelete"
                    :okText="$t('publicLang.Yes')"
                    :cancelText="$t('publicLang.No')"
            >
                <img class="sbxs mllr4" src="../../../assets/img/ss-delete.png" width="25" height="25" >
            </a-popconfirm>
        </a-row>
        <a-row>
            <vxe-table
                stripe
                highlight-hover-row
                border
                resizable
                show-overflow
                ref="multilingualRef"
                size="mini"
                @cell-dblclick="cellClickEvent"
                :data="tableData">
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="langType" title="Lang Type" minWidth="80" :formatter="formatLangType"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="langName" title="Lang Name" minWidth="80"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="creator" title="Creator" minWidth="80"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="createTime" title="Create Date" minWidth="80"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="modifier" title="Modifier" minWidth="80"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="modifyTime" title="Modiy Date" minWidth="80"></vxe-table-column>
            </vxe-table>
        </a-row>

        <a-modal v-model="addVisible" title="Add Multilingual">
            <template slot="footer">
                <a-button type="primary" size="small" @click="saveLangAdd">Save</a-button>
            </template>
            <a-form :form="addLangForm" class="mtb8">
                <a-form-item label="Language Type" v-bind="formItemLayout">
                    <a-select
                            size="small"formatLangType
                            style="width: 100%"
                            v-decorator="['langType',{initialValue: targetRow.langType}]">
                        <a-select-option value="EN">English</a-select-option>
                        <a-select-option value="SCN">Simplified Chinese</a-select-option>
                        <a-select-option value="TCN">Traditional Chinese</a-select-option>
                        <a-select-option value="KOR">Korean</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="Language Name" v-bind="formItemLayout">
                    <a-input
                        size="small"
                        autocomplete="off"
                        v-decorator="['langName',{  initialValue: targetRow.langName, rules: [{max: 100}]}]"/>
                </a-form-item>
            </a-form>
        </a-modal>

    </div>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    export default{
        props:{
            leftTargetUid:{
                type: String,
                default: function () {
                    return '';
                }
            }
        },
        data(){
            return{
                tableData: [],
                addVisible:false,
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                addLangForm:this.$form.createForm(this),
                targetRow:{}
            }
        },
        created(){
            this.init()
        },
        watch:{
            leftTargetUid(){
                this.init()
            }
        },
        methods:{
                formatLangType({ row }) {
                   
                 let typeValue = '';
                 if(row.langType == 'EN'){
                    typeValue = 'English'
                 }else if(row.langType == 'SCN'){
                     typeValue = 'Simplified Chinese'
                 }else if(row.langType == 'TCN'){
                     typeValue = 'Traditional Chinese'
                 }else if(row.langType == 'JP'){
                     typeValue = 'Japanese'
                 }else if(row.langType == 'KOR'){
                     typeValue = 'Korean'
                 }
              
                return typeValue;
          },
  
            langDelete(){
                let arr = this.$refs.multilingualRef.getCheckboxRecords()
                let uids = []
                if(arr.length > 0){
                    for(let i in arr){
                        uids.push(arr[i].uid)
                    }
                    ajax.post(api.GENERICEXTGENERICDELGEEXTML,{geExtMlUids: uids}).then(res=>{
                        if(res.code == 200){
                            this.init()
                            this.$message.success(res.msg);
                        }else{
                            this.$customMessage.warning(res.msg);
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'));
                }
            },
            init(){
                ajax.get(api.GENERICEXTGENERICGEEXTML,{geExtDetailUid: this.leftTargetUid}).then(res=>{
                    this.tableData = res.data
                    // if(this.tableData.length > 0){
                    //     for(let i in this.tableData){
                    //         if(this.tableData[i].langType == 'EN'){
                    //             this.tableData[i].langType = 'English'
                    //         }else if(this.tableData[i].langType == 'SCN'){
                    //             this.tableData[i].langType = 'Simplified Chinese'
                    //         }else if(this.tableData[i].langType == 'TCN'){
                    //             this.tableData[i].langType = 'Traditional Chinese'
                    //         }else if(this.tableData[i].langType == 'JP'){
                    //             this.tableData[i].langType = 'Japanese'
                    //         }
                    //     }
                    // }
                })
            },
            createLang(){
                this.addVisible = true
                this.addLangForm.resetFields();
                this.targetRow = {}
            },
            cellClickEvent({row}){
                this.createLang()
                this.targetRow = row
            },
            saveLangAdd(){
                this.addLangForm.validateFields((err,values)=>{
                    if (!err){
                        let params = {
                            "extDetailUid": this.leftTargetUid,
                            "langName": values.langName,
                            "langType": values.langType,
                        }
                        if(this.targetRow.uid){
                            params.uid = this.targetRow.uid
                        }
                        ajax.post(api.GENERICEXTGENERICGEEXTML,params).then(res=>{
                            if(res.code == 200){
                                this.addVisible = false
                                this.init()
                                this.$message.success(res.msg);
                            }else{
                                this.$customMessage.warning(res.msg);
                            }
                        })
                    }
                })
            }
        }
    }
</script>